import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

const getImageUrl = (path) => {
  const { data } = supabase.storage.from("animalia").getPublicUrl(path);
  return data?.publicUrl || "";
};

export default function GestionnaireSliderPrincipal() {
  const [mainSlider, setMainSlider] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState(null);

  const [elementModifie, setElementModifie] = useState(null);
  const [formulaire, setFormulaire] = useState({
    title: "",
    image_path: "",
  });
const [previewUrl, setPreviewUrl] = useState("");

useEffect(() => {
  if (formulaire.image_path) {
    const url = getImageUrl(formulaire.image_path);
    setPreviewUrl(url);
  }
}, [formulaire.image_path]);

  const chargerDonnees = async () => {
    setChargement(true);
    const { data, error } = await supabase.from("main").select("*");
    if (error) {
      setErreur(error.message);
    } else {
      setMainSlider(data);
      setErreur(null);
    }
    setChargement(false);
  };

  useEffect(() => {
    chargerDonnees();
  }, []);

  const gererChangement = (e) => {
    setFormulaire((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const gererSoumission = async (e) => {
    e.preventDefault();

    if (elementModifie) {
      const { error } = await supabase
        .from("main")
        .update(formulaire)
        .eq("id", elementModifie.id);

      if (error) {
        alert("Échec de la mise à jour : " + error.message);
      } else {
        alert("Mis à jour avec succès");
        setElementModifie(null);
        setFormulaire({ title: "", image_path: "" });
        chargerDonnees();
      }
    } else {
      const { error } = await supabase.from("main").insert([formulaire]);

      if (error) {
        alert("Échec de l'ajout : " + error.message);
      } else {
        alert("Ajouté avec succès");
        setFormulaire({ title: "", image_path: "" });
        chargerDonnees();
      }
    }
  };

  const gererEdition = (item) => {
    setElementModifie(item);
    setFormulaire({
      title: item.title || "",
      image_path: item.image_path || "",
    });
  };

const gererFichier = async (e) => {
  const fichier = e.target.files[0];
  if (!fichier) return;

  try {
    const extension = fichier.name.split(".").pop();
    const nomFichier = `${Date.now()}.${extension}`;
const cheminFichier = `slider/${nomFichier}`;

    let { data, error: erreurUpload } = await supabase.storage
  .from("animalia")
  .upload(cheminFichier, fichier, {
    cacheControl: "3600",
    upsert: false,
  });

console.log("Upload result:", data, erreurUpload);

    if (erreurUpload) {
      alert("Échec de l'upload : " + erreurUpload.message);
      return;
    }

    setFormulaire((prev) => ({
      ...prev,
      image_path: cheminFichier,
    }));
  } catch (error) {
    alert("Erreur d'upload : " + error.message);
  }
};


  const gererSuppression = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cet élément ?")) {
      const { error } = await supabase.from("main").delete().eq("id", id);
      if (error) {
        alert("Échec de la suppression : " + error.message);
      } else {
        alert("Supprimé avec succès");
        chargerDonnees();
      }
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        backgroundColor: "#f8f9fa",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* <h2 style={{ marginBottom: 30, color: "#343a40" }}>
        Gestionnaire du Slider Principal
      </h2> */}

      {/* Formulaire d'ajout/modification */}
      <form
        onSubmit={gererSoumission}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 15,
          maxWidth: 700,
          backgroundColor: "#fff",
          padding: 20,
          borderRadius: 8,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          marginBottom: 40,
        }}
      >
        <h3 style={{ width: "100%", color: "#495057" }}>
          {elementModifie ? "Modifier la diapositive" : "Ajouter une diapositive"}
        </h3>

        <input
          type="text"
          name="title"
          placeholder="Titre"
          value={formulaire.title}
          onChange={gererChangement}
          required
          style={inputStyle}
        />

        {/* <label style={{ fontWeight: "600", marginBottom: 6 }}>
          Télécharger une image
        </label> */}
        <input
          type="file"
          accept="image/*"
          onChange={gererFichier}
          style={inputStyle}
        />
{previewUrl && (
  <img
    src={previewUrl}
    alt="Aperçu"
    style={{ maxWidth: "200px", marginTop: "10px", borderRadius: "6px" }}
  />
)}

        <div style={{ display: "flex", gap: 10, marginTop: 10, width: "100%" }}>
          <button type="submit" style={buttonStyle}>
            {elementModifie ? "Mettre à jour" : "Ajouter"}
          </button>
          {elementModifie && (
            <button
              type="button"
              onClick={() => {
                setElementModifie(null);
                setFormulaire({ title: "", image_path: "" });
              }}
              style={{ ...buttonStyle, backgroundColor: "#6c757d" }}
            >
              Annuler
            </button>
          )}
        </div>
      </form>

      {/* Message d'erreur */}
      {erreur && (
        <p style={{ color: "red", marginBottom: 20, fontWeight: "bold" }}>
          {erreur}
        </p>
      )}

      {/* État de chargement */}
      {chargement && <p>Chargement des diapositives...</p>}

      {/* Cartes horizontales */}
      <div
        style={{
          display: "flex",
          gap: 24,
          overflowX: "auto",
          maxWidth: "90vw",
          paddingBottom: 20,
          justifyContent: "center",
          scrollbarWidth: "thin",
        }}
      >
        {mainSlider.map((item) => (
          <div
            key={item.id}
            style={{
              minWidth: 280,
              backgroundColor: "#fff",
              borderRadius: 10,
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              padding: 15,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={
                item.image_path
                  ? getImageUrl(item.image_path)
                  : "https://via.placeholder.com/280x150?text=Pas+d'image"
              }
              alt={item.title || "Image"}
              style={{
                width: "100%",
                height: 150,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 15,
              }}
            />

            <h4
              style={{
                color: "#212529",
                marginBottom: 8,
                textAlign: "center",
                minHeight: 48,
              }}
            >
              {item.title}
            </h4>

            <div style={{ display: "flex", gap: 12 }}>
              <button
                onClick={() => gererEdition(item)}
                style={{
                  ...buttonStyle,
                  backgroundColor: "rgba(255, 65, 180, 0.8)",
                }}
              >
                Modifier
              </button>
              <button
                onClick={() => gererSuppression(item.id)}
                style={{
                  ...buttonStyle,
                  backgroundColor: "rgba(220, 53, 69, 0.8)",
                }}
              >
                Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const inputStyle = {
  flex: "1 1 200px",
  padding: "10px 12px",
  borderRadius: 6,
  border: "1.5px solid #ced4da",
  fontSize: 16,
  outline: "none",
  transition: "border-color 0.3s",
};

const buttonStyle = {
  padding: "10px 18px",
  border: "none",
  borderRadius: 6,
  color: "#fff",
  fontWeight: "600",
  cursor: "pointer",
  flex: 1,
  backgroundColor: "gray",
  transition: "background-color 0.3s",
};
